/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smug_Few_Leopard_LinkInputs */

const en_smug_few_leopard_link = /** @type {(inputs: Smug_Few_Leopard_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more`)
};

const de_smug_few_leopard_link = /** @type {(inputs: Smug_Few_Leopard_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr erfahren`)
};

/**
* | output |
* | --- |
* | "Learn more" |
*
* @param {Smug_Few_Leopard_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const smug_few_leopard_link = /** @type {((inputs?: Smug_Few_Leopard_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smug_Few_Leopard_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_smug_few_leopard_link(inputs)
	return de_smug_few_leopard_link(inputs)
});